import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import styled from 'styled-components'

export const Form = styled.form`
    width: 914px;
    position: relative;
    display: flex;
    z-index:1;

    @media screen and (max-width: 1023px) {
        width: 100%;
    }
`

export const SearchInput = styled.input`
    width: 100%;
    height: 44px;
    border-radius: 2px;
    border: none;
    padding-left: 16px;
    outline: none;
    padding-right: 230px;

    @media screen and (max-width: 767px) {
        padding-right: 44px;
    }
`

export const SearchSubmit = styled.button`
    position: absolute;
    width: 44px;
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0;
    top: 0;
    outline:none;
    border: none;
    background: none;
    cursor: pointer;
`

export const SearchIc = styled(SearchIcon)`
    color: #525252;
`

export const ClearButton = styled(CloseIcon)`
    cursor: pointer;
    position: absolute;
    color: #2A2A2A;
    right: -27px;
    top: 50%;
    transform: translateY(-50%);
`
export const SelectWrap = styled.div`
    width: 160px;
    position: absolute;
    right: 45px;
    top: 50%;
    transform: translateY(-50%);
`

